import React, { useState } from 'react'
import Modal from '../../blocks/Modal'
import Button from '../../blocks/Button'
import './PrintModal.scss'

export default function PrintModal(props) {
  const { onClose, stage } = props;

  const [waiting, setWaiting] = useState(false);

  if (stage === 0) { return null; }

  if (stage === 1) {
    return <Modal isOpen={true} renderCloseIcon={false} onClose={onClose}>
      <div className='certPrintModal'>
        <div className='modalContent'>
          <div className='modalTitle'>
            Print Certificates
          </div>
          <div className='modalText'>
            Some of the badges in your selection have not yet been awarded.<br/>
            Click "Proceed" to award eligible badges before printing certificates.
          </div>
        </div>
        <div className='modalControls'>
          <Button onClick={onConfirm} waiting={waiting}>Proceed</Button>
          <Button type='secondary' onClick={onClose}>Cancel</Button>
        </div>
      </div>
    </Modal>
  }

  if (stage === 2) {
    return <Modal isOpen={true} renderCloseIcon={false} onClose={onClose}>
      <div className='certPrintModal'>
        <div className='modalContent'>
          <div className='modalTitle'>
            Certificate Color
          </div>
          <div className='modalText'>
            Select whether to print certificates in color or black/white.
          </div>
        </div>
        <div className='modalControls'>
          <Button onClick={() => props.onSubmit(true)} waiting={waiting}>Color</Button>
          <Button onClick={() => props.onSubmit(false)} waiting={waiting}>Black/White</Button>
          <Button type='secondary' onClick={onClose}>Cancel</Button>
        </div>
      </div>
    </Modal>
  }

  async function onConfirm() {
    setWaiting(true); 
    await props.onConfirm();
    setWaiting(false);
  }
}